import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompetitionClassForm from '../../../components/forms/CompetitionClassForm';
import { useCompetitionClassApi } from '../../../hooks/useCompetitionClassApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { CompetitionClassDTO } from '../../../services/apiClient';

const CompetitionClassEdit: React.FC = () => {
  const { getById, edit, isLoading } = useCompetitionClassApi();
  const [entityData, setEntityData] = useState<CompetitionClassDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competition Classes', href: '/admin/competitionclasses' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching CompetitionClass data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/competitionclasses');
    } catch (error) {
      console.error('Error updating CompetitionClass:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/competitionclasses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.CompetitionClass.Edit'
    >
        {entityData ? (
          <CompetitionClassForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/competitionclasses')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default CompetitionClassEdit;